import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['languageSelect']

  initialize() {
    const languageSelect = $(this.languageSelectTarget).select2()

    // Redirect to the same URL with the selected locale as a query param
    languageSelect.on('change', () => {
      const selectedLocale = languageSelect.val();
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('locale', selectedLocale);
        window.location.href = url.href;
      } catch (e) {
        // Fallback for older browsers
        console.warn('Failed to update locale in URL, using fallback.', e);
        window.location.href = window.location.pathname + '?locale=' + encodeURIComponent(selectedLocale);
      }
    })
  }
}
